// extracted by mini-css-extract-plugin
module.exports = {"link":"SidebarLinkElement_link__2ex5E","selectedLink":"SidebarLinkElement_selectedLink__hv_cA"};